<!-- <div class="stripe-banner" id="stripBanner">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <p><b>Upgrade Alert!</b>  Trinka AI is now <b>40%</b> more powerful. It's much faster, more accurate, and corrects more errors than ever before. <span class="d-block">Also, note that Trinka  <b>does not use ChatGPT/GPT-X</b>. It uses our own proprietary patented AI technology for grammar corrections and suggestions. 🎉 </span></p>
            </div>
        </div>
    </div>
</div> -->

<header class="wrapper bg-soft-primary" id="header" [ngClass]="{'headerSticky' : true, 'sticky' : notSticky}">
    <nav class="navbar navbar-expand-xl center-nav transparent navbar-light">
      <div class="container flex-lg-row flex-nowrap align-items-center">
        <div class="navbar-brand w-100">
          <a [routerLink]="['/']">
            <img src="../../../assets/images/trinka_logo.svg" width="183" height="73" alt="trinka-grammar-checker">
          </a>
        </div>
        <div class="navbar-collapse offcanvas offcanvas-nav offcanvas-start justify-content-end" [ngClass]="{'show': isMenuActive}">
          <div class="offcanvas-header d-xl-none">
            <img src="../../../assets/images/trinka_logo.svg" loading="lazy" decoding="async" width="140" alt="trinka-grammar-checker">
            <button type="button" class="btn-close" (click)="closeCanvasMenu()" aria-label="Close Navigation Menu">
                <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M46.5 15.5L15.5 46.5" stroke="#4D4D4D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M15.5 15.5L46.5 46.5" stroke="#4D4D4D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
          </div>
          <div class="offcanvas-body ms-lg-auto d-flex flex-column h-100">
            <ul class="navbar-nav">
                <li class="nav-item dropdown dropdown-mega" >
                    <p class="nav-link dropdown-toggle" (click)="toggleClass($event)" data-toggle="dropdown"><span>產品</span> <img src="../../../../assets/icons/chevron-up.svg" alt="icon" /></p>
                    <ul class="dropdown-menu mega-menu">
                        <li class="mega-menu-content row">
                            <div class="col-12 dflex mega-card">
                                <div class="menu-card features-card c-card">
                                    <h3 class="mb-40" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas"><a class="font-500" [routerLink]="['/features']">特色</a></h3>
                                    <div class="media-card">
                                        <a [routerLink]="['/features/grammar-checker']">
                                            <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/grammar-checker.svg" loading="lazy" decoding="async" alt="grammar-checker" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>文法檢查</h5>
                                                    <p>以高級文法檢查技術，全方位提升您的寫作品質。</p>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/features/paraphraser']">
                                            <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/pharaphraser.svg" loading="lazy" decoding="async" alt="Paraphraser" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>文章改寫</h5>
                                                    <p>理解您文章的語意，提供最佳替換用語。</p>
                                                </div>
                                            </div>
                                        </a>
                                        <div class="px-menu">
                                            <a [routerLink]="['/features/proofread-file']" (click)="closeCanvasMenu()">
                                                <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                    <div class="media-left">
                                                        <img src="../../../assets/images/menu-icons/proofread.svg" loading="lazy" decoding="async" alt="Proofread File" />
                                                    </div>
                                                    <div class="media-body">
                                                        <h5>自動文件編輯</h5>
                                                        <p>自動修正文稿，節省您寶貴的時間，幾秒內完成編輯。</p>
                                                    </div>
                                                </div>
                                            </a>

                                            <ul class="tx-inline-menu">
                                                <li>
                                                    <a [routerLink]="['/features/proofread-file']" (click)="closeCanvasMenu()">
                                                        MS-Word
                                                    </a>
                                                </li>
                                                <li>
                                                    <a [routerLink]="['/features/latex-grammar-checker']" (click)="closeCanvasMenu()">
                                                        Latex 文件
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="px-menu">
                                            <a [routerLink]="['/features/ai-studio/ai-writing-tools']">
                                                <div class="media" (click)="closeCanvasMenu()">
                                                    <div class="media-left">
                                                        <img src="../../../assets/images/menu-icons/ai-studio.svg" width="25" height="25" alt="AI Studio" />
                                                    </div>
                                                    <div class="media-body">
                                                        <h5>AI Studio <i style="position:relative;right: -5px;top:-2px">全新推出</i></h5>
                                                        <p>先進高品質內容創作應用程式，協助 AI 輔助寫作。</p>
                                                    </div>
                                                </div>
                                            </a>
                                            <ul class="tx-inline-menu">
                                                <li>
                                                    <a [routerLink]="['/features/ai-studio/ai-writing-tools']" (click)="closeCanvasMenu()">
                                                        AI 寫作工具
                                                    </a>
                                                </li>
                                                <li>
                                                    <a [routerLink]="['/features/ai-studio/ai-assisted-writing']" (click)="closeCanvasMenu()">
                                                        AI 智慧寫作助手
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <a [routerLink]="['/features/consistency-check']">
                                            <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/consistency.svg" loading="lazy" decoding="async" alt="Consistency Check" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>一致性檢查</h5>
                                                    <p>自動修正難以發現的用詞與格式不一致問題。</p>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/enterprise/sensitive-data-plan']">
                                            <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/data-sensitive.svg" loading="lazy" decoding="async" alt="Sensitive Data Plan" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>敏感資料方案</h5>
                                                    <p>最高等級安全保障，不儲存資料且不進行 AI 訓練。</p>
                                                    
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/features/inclusive-language-check']">
                                            <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/inclusive-language.svg" loading="lazy" decoding="async" alt="Inclusive Language Check" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>中性語言檢查</h5>
                                                    <p>偵測並排除帶有偏見或歧視的用語。</p>
                                                </div>
                                            </div>
                                        </a>
                                        <ul class="tx-inline-menu bullets-menu">
                                            <li>
                                                <a [routerLink]="['/features/legal-writing']">
                                                    <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                        法律寫作
                                                    </div>
                                                </a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/personal-dictionary']">
                                                    <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                        個人詞典
                                                    </div>
                                                </a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/credits']">
                                                    <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                        Trinka 點數
                                                    </div>
                                                </a>
                                            </li>
                                        </ul>
                                        <!-- <a [routerLink]="['/features/personal-dictionary']">
                                            <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/personal-dictionary.svg" loading="lazy" decoding="async" alt="Personal Disctionary" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>Personal Dictionary</h5>
                                                    <p>Avoid spelling alerts for new terms with your own dictionary.</p>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/features/legal-writing']">
                                            <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/legal-writing.svg" loading="lazy" decoding="async" alt="Legal Writing" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>Legal Writing</h5>
                                                    <p>Ensures improved legal documents in seconds.</p>
                                                </div>
                                            </div>
                                        </a> -->
                                    </div>
                                </div>
                                <div class="menu-card hr-line c-card"></div>
                                <div class="menu-card reports-card c-card">
                                    <h3 class="mb-40">報告功能</h3>
                                    <div class="media-card">
                                        <!-- <a [routerLink]="['/features/documark']">
                                            <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/documark.svg" width="25" height="25" alt="DocuMark" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>DocuMark <i style="position:relative;right: -5px;top:-2px">New</i></h5>
                                                    <p>Transparency Tool to Reduce Faculty Stress & Guide Students to Own AI Use.</p>
                                                </div>
                                            </div>
                                        </a> -->
                                        <a [routerLink]="['/features/plagiarism-check']">
                                            <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/plagiarism.svg" loading="lazy" decoding="async" alt="plagiarism" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>抄襲檢查工具</h5>
                                                    <p>比對全球最大付費及開放資料庫，確保原創性。</p>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/features/ai-content-detector']">
                                            <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/ai-detector.svg" loading="lazy" decoding="async" alt="Technical Checks" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>AI 內容檢測工具</h5>
                                                    <p>辨識由大型語言模型產生的文本，維護內容真實性。</p>
                                                </div>
                                            </div>
                                        </a>
                                        <!-- <a [routerLink]="['/features/journal-finder']">
                                            <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/journal-finder.svg" loading="lazy" decoding="async" alt="Journal Finder" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>Journal Finder</h5>
                                                    <p>Helps you find the right journal for your paper quickly.</p>
                                                </div>
                                            </div>
                                        </a> -->
                                        <div class="px-menu w-100" style="max-width:100%">
                                            <a [routerLink]="['/features/citation-checker']">
                                                <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                    <div class="media-left">
                                                        <img src="../../../assets/images/menu-icons/citation-checker.svg" loading="lazy" decoding="async" alt="Citation Checker" />
                                                    </div>
                                                    <div class="media-body">
                                                        <h5>引文檢查器</h5>
                                                        <p>檢查引用品質，驗證並格式化各大引用格式。</p>
                                                    </div>
                                                </div>
                                            </a>
                                            <ul class="tx-inline-menu">
                                                <li>
                                                    <a [routerLink]="['/features/citation-checker']" (click)="closeCanvasMenu()">
                                                        引文檢查器
                                                    </a>
                                                </li>
                                                <li>
                                                    <a [routerLink]="['/features/citation-formatter']" (click)="closeCanvasMenu()">
                                                        引文格式整理器
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <a [routerLink]="['/features/journal-finder']">
                                            <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/journal-finder.svg" loading="lazy" decoding="async" alt="Journal Finder" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>期刊查找</h5>
                                                    <p>快速找到適合您論文投稿的期刊。</p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div class="menu-card hr-line c-card"></div>
                                <div class="menu-card apps-card c-card">
                                    <h3 class="mb-40">應用程式</h3>
                                    <div class="media-card gap-sm">
                                        <a [routerLink]="['/trinkacloud']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/cloud.svg" loading="lazy" decoding="async" alt="Cloud" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>雲端服務</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/wordplugin']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/word-addin.svg" loading="lazy" decoding="async" alt="Word Add-in" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>Word 外掛程式</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/wordplugin-lite']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/word-addin.svg" loading="lazy" decoding="async" alt="Word Add-in Lite" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>Word 外掛輕量版</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/windows-desktop-app']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/windows-app.svg" loading="lazy" decoding="async" alt="Word Add-in Lite" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>Windows 桌面應用程式</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/browser-plugin']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/browser-plugin.svg" loading="lazy" decoding="async" alt="Browser Plugins" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>瀏覽器擴充功能</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <!-- <div class="btn-group d-xl-block d-none">
                                            <a  id="GCChromeButton" href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank" rel="noopener noreferrer" class="filled-btn"><img src="../../../assets/images/NewChromeIcon.svg" loading="lazy" decoding="async" width="32" height="32" alt="chrome">Chrome</a>
                                            <a  id="GCFirFoxButton" href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank" rel="noopener noreferrer" class="filled-btn"><img src="../../../assets/images/NewFirefoxIcon.svg" loading="lazy" decoding="async"  width="32" height="32" alt="firefox ">Firefox</a>
                                            <a  id="GCEdgeButton" href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank" rel="noopener noreferrer" class="filled-btn"><img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" loading="lazy" decoding="async"  width="32" height="32" alt="edge">Edge</a>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </li>
                    <!--/.mega-menu-content-->
                    </ul>
                    <!--/.dropdown-menu -->
                </li>
                <li class="nav-item dropdown dropdown-mega" >
                    <p class="nav-link dropdown-toggle" (click)="toggleClass($event)" data-toggle="dropdown"><span>Trinka 商務版</span> <img src="../../../../assets/icons/chevron-up.svg" alt="icon" /></p>
                    <ul class="dropdown-menu mega-menu">
                        <li class="mega-menu-content row">
                            <div class="col-12 dflex mega-card">
                                <div class="menu-card trinka-business-menu industries">
                                    <h3 (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas"><a class="font-500" [routerLink]="['/enterprise']">Industries - 企業產業方案</a></h3>
                                    <div class="media-card">
                                        <div class="px-menu">
                                            <a [routerLink]="['/enterprise/academic-institutions']">
                                                <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                    <div class="media-left">
                                                        <img src="../../../assets/images/menu-icons/universities.svg" loading="lazy" decoding="async" alt="Universities" />
                                                    </div>
                                                    <div class="media-body">
                                                        <h5>學術機構</h5>
                                                        <p>提供學生及教職員完整的寫作輔助。</p>
                                                    </div>
                                                </div>
                                            </a>
                                            <ul class="tx-inline-menu">
                                                <li>
                                                    <a [routerLink]="['/enterprise/academic-institutions']" (click)="closeCanvasMenu()">
                                                        大專院校
                                                    </a>
                                                </li>
                                                <li>
                                                    <a [routerLink]="['/enterprise/k12-and-elearning']" (click)="closeCanvasMenu()">
                                                        K-12 及線上學習方案
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <span class="enterpise-line"></span>

                                    <div class="media-card">
                                        <div class="px-menu">
                                            <a [routerLink]="['/enterprise/language-services-publishing-and-media']">
                                                <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                    <div class="media-left">
                                                        <img src="../../../assets/images/menu-icons/language-services.svg" loading="lazy" decoding="async" alt="Publishers" />
                                                    </div>
                                                    <div class="media-body">
                                                        <h5>語言服務、出版與媒體</h5>
                                                        <p>運用 AI 提升出版流程效率。</p>
                                                    </div>
                                                </div>
                                            </a>
                                            <ul class="tx-inline-menu">
                                                <li>
                                                    <a [routerLink]="['/enterprise/language-services-publishing-and-media']" (click)="closeCanvasMenu()">
                                                        出版商
                                                    </a>
                                                </li>
                                                <li>
                                                    <a [routerLink]="['/enterprise/language-services-publishing-and-media']" (click)="closeCanvasMenu()">
                                                        語言服務
                                                    </a>
                                                </li>
                                                <li>
                                                    <a [routerLink]="['/enterprise/language-services-publishing-and-media']" (click)="closeCanvasMenu()">
                                                        媒體與網站
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <span class="enterpise-line"></span>

                                    <div class="media-card">
                                        <div class="px-menu">
                                            <a [routerLink]="['/enterprise/life-sciences-medicine-and-pharma']">
                                                <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                    <div class="media-left">
                                                        <img src="../../../assets/images/menu-icons/premises.svg" loading="lazy" decoding="async" alt="for businesses" />
                                                    </div>
                                                    <div class="media-body">
                                                        <h5>企業方案</h5>
                                                        <p>量身打造專業文件的產業解決方案。</p>
                                                    </div>
                                                </div>
                                            </a>
                                            <ul class="tx-inline-menu">
                                                <li>
                                                    <a [routerLink]="['/enterprise/life-sciences-medicine-and-pharma']" (click)="closeCanvasMenu()">
                                                        醫療與製藥
                                                    </a>
                                                </li>
                                                <li>
                                                    <a [routerLink]="['/enterprise/technology-platforms']" (click)="closeCanvasMenu()">
                                                        科技與軟體
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="menu-card hr-line c-card"></div>
                                <div class="menu-card  trinka-business-menu industries">
                                    <h3>資料保護</h3>
                                    <div class="media-card">
                                        <div class="px-menu">
                                            <a [routerLink]="['/enterprise/sensitive-data-plan']">
                                                <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                    <div class="media-left">
                                                        <img src="../../../assets/images/menu-icons/data-sensitive.svg" loading="lazy" decoding="async" alt="Sensitive Data Plan" />
                                                    </div>
                                                    <div class="media-body">
                                                        <h5>敏感資料方案</h5>
                                                        <p>最高安全等級，不保存資料且不用於 AI 訓練。</p>
                                                        
                                                    </div>
                                                </div>
                                            </a>
                                            <ul class="tx-inline-menu">
                                                <li>
                                                    <a [routerLink]="['/enterprise/sensitive-data-plan']" (click)="closeCanvasMenu()">
                                                        概覽
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="/data-security" (click)="closeCanvasMenu()">
                                                        資料安全
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <span class="enterpise-line"></span>

                                    <h3 class="mt-1">資料安全</h3>

                                    <div class="media-card">
                                        <div class="px-menu">
                                            <a [routerLink]="['/enterprise/grammar-checker-api']">
                                                <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                    <div class="media-left">
                                                        <img src="../../../assets/images/menu-icons/api.svg" loading="lazy" decoding="async" alt="api" />
                                                    </div>
                                                    <div class="media-body">
                                                        <h5>API / SDK</h5>
                                                        <p>提供文法檢查 API 與 JavaScript SDK，支援即時或非即時文法檢查及完全客製化。</p>
                                                    </div>
                                                </div>
                                            </a>
                                            <ul class="tx-inline-menu">
                                                <li>
                                                    <a [routerLink]="['/enterprise/grammar-checker-api']" (click)="closeCanvasMenu()">
                                                        概覽
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="https://developer.trinka.ai/docs/getting-started" (click)="closeCanvasMenu()" target="_blank" rel="noopener noreferrer">
                                                        開發者文件
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <span class="enterpise-line"></span>

                                    <div class="media-card">
                                        <div class="px-menu">
                                            <a [routerLink]="['/enterprise/on-premise-grammar-checker']">
                                                <div class="media" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                    <div class="media-left">
                                                        <img src="../../../assets/images/menu-icons/on-premises.svg" loading="lazy" decoding="async" alt="premises" />
                                                    </div>
                                                    <div class="media-body">
                                                        <h5>企業內部部署</h5>
                                                        <p>在您的企業私有 IT 基礎架構運行 Trinka，全面掌控。</p>
                                                    </div>
                                                </div>
                                            </a>
                                            <ul class="tx-inline-menu">
                                                <li>
                                                    <a [routerLink]="['/enterprise/on-premise-grammar-checker']" fragment="onpremise" (click)="closeCanvasMenu()">
                                                        概覽
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="menu-card hr-line c-card"></div>
                                <div class="menu-card  trinka-business-menu industries">
                                    <h3>客製化 AI 模型</h3>
                                    <div class="media-card noMediaCard gap-0">
                                        <div class="media align-items-center no-hightlight" style="padding: 0 12px;margin: 0; padding-top:8px" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                            <div class="media-body">
                                                <p class="mt-0">打造專屬企業的 AI 模型，由您完全掌控。</p>
                                            </div>
                                        </div>
                                        <ul class="tx-inline-menu flex-column" style="margin: 8px 12px;">
                                            <li>
                                                <a [routerLink]="['/enterprise/custom-ai-models/overview']" (click)="closeCanvasMenu()">
                                                    概覽
                                                </a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/custom-ai-models/how-we-do-it']" (click)="closeCanvasMenu()">
                                                    我們的運作方式
                                                </a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/custom-ai-models/process']" (click)="closeCanvasMenu()">
                                                    流程
                                                </a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/custom-ai-models/why-choose-us']" (click)="closeCanvasMenu()">
                                                    為何選擇 Trinka？
                                                </a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/custom-ai-models/rlhf']" (click)="closeCanvasMenu()">
                                                    RLHF 技術介紹
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </li>
                    <!--/.mega-menu-content-->
                    </ul>
                    <!--/.dropdown-menu -->
                </li>
                <li class="nav-item dropdown">
                    <p class="nav-link dropdown-toggle" (click)="toggleClass($event)" data-toggle="dropdown"><span>計劃與價格</span> <img src="../../../../assets/icons/chevron-up.svg" alt="icon" /></p>
                    <ul class="dropdown-menu" id="planPricing">
                        <li class="row single-menu">
                            <div class="col-12 dflex mega-card">
                                <div class="menu-card">
                                    <div class="media-card gap-sm">
                                        <a [routerLink]="['/pricing']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/pricing.svg" loading="lazy" decoding="async" alt="pricing" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>價格說明</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/features/credits']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/credits-trinka.svg" loading="lazy" decoding="async" alt="credits" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>Trinka 點數</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/local-invoice']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/local-invoice.svg" loading="lazy" decoding="async" alt="invoice" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>發票與付款</h5>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </li>
                <li class="nav-item dropdown">
                    <p class="nav-link dropdown-toggle" (click)="toggleClass($event)" data-toggle="dropdown"><span>免費工具</span> <img src="../../../../assets/icons/chevron-up.svg" alt="icon" /></p>
                    <ul class="dropdown-menu">
                        <li class="row single-menu">
                            <div class="col-12 dflex mega-card">
                                <div class="menu-card">
                                    <div class="media-card gap-sm">
                                        <a [routerLink]="['/grammar-checker']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/grammar-checker.svg" loading="lazy" decoding="async" alt="Grammar Checker tool" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>文法檢查工具</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/paraphrasing-tool']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/pharaphraser.svg" loading="lazy" decoding="async" alt="Paraphrasing Tool" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>文章改寫工具</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/journal-finder']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/journal-finder.svg" loading="lazy" decoding="async" alt="Journal Finder" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>期刊查找 <i>全新推出</i></h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/ai-content-detector']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/ai-detector.svg" loading="lazy" decoding="async" alt="AI Content Detector" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>AI 內容檢測工具</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/academic-phrasebank']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/phrasebank.svg" loading="lazy" decoding="async" alt="phrasebank" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>學術寫作語句庫</h5>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </li>
                <li class="nav-item dropdown">
                    <p class="nav-link dropdown-toggle" (click)="toggleClass($event)" data-toggle="dropdown"><span>資源</span> <img src="../../../../assets/icons/chevron-up.svg" alt="icon" /></p>
                    <ul class="dropdown-menu">
                        <li class="row single-menu">
                            <div class="col-12 dflex mega-card">
                                <div class="menu-card">
                                    <div class="media-card gap-sm">
                                        <a href="https://www.enago.com/" target="_blank" rel="noopener noreferrer">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/human-editing.svg" loading="lazy" decoding="async" alt="case study" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>人工校稿服務</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <!-- <a href="/case-study">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/use-case.svg" loading="lazy" decoding="async" alt="case study" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>案例研究</h5>
                                                </div>
                                            </div>
                                        </a> -->
                                        <!-- <a target="_blank" rel="noopener" href="https://www.trinka.ai/blog/">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/blogs.svg" loading="lazy" decoding="async" alt="Blogs" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>部落格</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a href="/podcast">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/podcast.svg" loading="lazy" decoding="async" alt="podcast" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>播客</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a  href="/news">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/news.svg" loading="lazy" decoding="async" alt="news" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>最新消息</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a  href="/webinars">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/webinars.svg" loading="lazy" decoding="async" alt="webinars" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>線上研討會</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a  href="/resources/newsletters">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/newsletter.svg" loading="lazy" decoding="async" alt="webinars" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>Newsletters</h5>
                                                </div>
                                            </div>
                                        </a> -->
                                        <!-- <a  href="/videos">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/videos.svg" loading="lazy" decoding="async" alt="videos" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>影片</h5>
                                                </div>
                                            </div>
                                        </a> -->
                                        <a href="/trinka-vs-grammarly-vs-language-tool">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="../../../assets/images/menu-icons/whitepaper.svg" loading="lazy" decoding="async" alt="Whitepaper" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>白皮書</h5>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </li>
                <!-- <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/aboutus']" data-bs-dismiss="offcanvas"><span>About Us</span></a>
                </li> -->
            </ul>
            <!-- /.offcanvas-footer -->
          </div>
          <!-- /.offcanvas-body -->
        </div>
        <div class="offcanvas-backdrop fade" (click)="closeCanvasMenu()" [ngClass]="{'show': isBackdropActive}"></div>
        <!-- /.navbar-collapse -->
        <div class="navbar-other w-100 d-flex ms-auto justify-content-end">
          <ul class="navbar-nav flex-row align-items-center ms-auto">
            <li class="nav-item">
                <div class="btn-group-header">
                    <a id="SignupForFree" class="btn-signup" href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank" rel="noopener noreferrer">
                        免費試用
                    </a>
                    <a id="loginButtons" class="btn-login" href="https://cloud.trinka.ai/signin?_rg=TW" target="_blank" rel="noopener noreferrer">
                        <span>登入</span>
                    </a>
                </div>   
            </li>
            <!-- <li class="nav-item"><a class="nav-link" data-es-toggle="offcanvas" data-bs-target="#offcanvas-info"><i class="uil uil-info-circle"></i></a></li> -->
            <li class="nav-item d-xl-none">
                <button class="hamburger offcanvas-nav-btn" aria-label="Open Navigation Menu" id="hamburger-menu" (click)="toggleOffCanvasMenu()"><span></span><span></span><span></span></button>
            </li>
          </ul>
        
        </div>
        <!-- /.navbar-other -->
        <div class="language_sections" id="languageDropDown">
            <i class="fa fa-globe" aria-hidden="true"></i>
            <span>繁體中文</span>
            <ul class="drop">
                <li>
                    <a href="https://www.trinka.ai/">English</a>
                </li>
                <li>
                    <a href="https://www.trinka.ai/jp/">
                        日本語
                    </a>
                </li>
                <li>
                    <a href="https://trinka.enago.cn/">
                        简体中文
                    </a>
                </li>
                <li class="selected">
                    <i class="fa fa-check" aria-hidden="true"></i>
                    <a href="https://www.trinka.ai/tw/">
                        繁體中文
                    </a>
                </li>
                <li>
                    <a href="https://www.trinka.ai/kr/">
                        한국어
                    </a>
                </li>
                <li>
                    <a href="https://www.trinka.ai/es/">
                        Español
                    </a>
                </li>
                <li>
                    <a href="https://www.trinka.ai/pt/">
                        Português
                    </a>
                </li>
            </ul>
        </div>
      </div>
      <!-- /.container -->
    </nav>
    <!-- /.navbar -->
</header>
<!-- /header -->